const SuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className="fixed cursor-pointer w-full h-full flex justify-center items-center bg-[#0A0F2D4D] top-0 left-0 z-50 backdrop-blur-md transition-all duration-300 ease-in-out"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[500px] bg-white rounded-2xl p-8 transition-all duration-300 ease-in-out transform"
      >
        <div className="w-full text-center text-[#1A212F] text-xl font-bold mb-3">
          Support request sent.
        </div>
        <div className="w-full text-center text-[#1A212F] text-base mb-6">
          We'll get in touch with you soon.
        </div>
        <div className="flex w-full justify-center">
          <div
            onClick={(e) => {
              e.stopPropagation();
              onClose();
            }}
            className="cursor-pointer bg-[#2283FF] text-white rounded-lg px-6 py-3 text-center text-[14px] font-medium"
          >
            Go to Home
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal; 